module.exports = __webpack_public_path__ + "/login_ui/img/as-0f86acd195a5301cf60363c3cfebdc0d.svg";